/*BLOQUE DE ARMONIZACION CONTABLE */

export const situacionfinanciera = [
    
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
            /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },*/
      
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
      
        ]
    },  
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
        ]
    }, 
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/EXCEL/1.- Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/b).- Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/EXCEL/1.Estado Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/1.Estado de Situación Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/EXCEL/1.-Estado Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/1.Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/1.Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/1.Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            }
            
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            
        ]
    },
     {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                     "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            
        ]
    },

     {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Estado de Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            
        ]
    },
];
export const estadoActividades = [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },
          /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },*/

        ]
    },   
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },

        ]
    },   
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },

        ]
    }, 
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/EXCEL/2.- Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/a).- Estado de Actividades.pdf",
                        
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/EXCEL/2.Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/2.Estado de Actividades.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/EXCEL/2.-Estado Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/2.Estado de Actividades.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/EXCEL/2.-Estado Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/2.Estado de Actividades.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Estado de Actividades.pdf",
                    }
            
                ]
                
            }
        ]
    },
];
export const ACvariacionHP = [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },
          /*  {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },*/


        ]
    },{
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },


        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },


        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/EXCEL/3.- Estado de Variaciones en la Hacienda Publica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/c).- Estado de Variacion en la Hacienda Publica.pdf",
                        
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/EXCEL/3.Estado de Variacion en la Hacienda Publica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/3.Estado de Variaciones en la Hacienda Publica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/EXCEL/3.-Estado Variacion Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/3.Estado de Variacion en la Hacienda Publica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/EXCEL/3.-Estado Variacion Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/3.Estado de Variacion en la Hacienda Publica.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Estado de Variacion en la Hacienda.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const ACEstadoCambiosSF = [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },
          /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },*/
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },

           
           
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/EXCEL/4.- Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/d).- Estado de Cambios en la Situacion Financiera.pdf",
                        
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/EXCEL/4.Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/4.Estado de Cambios en la Situación Financiera.pdf",
                    }
            
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/EXCEL/4.-Estado Cambios Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/4.Estado de Cambios en la Situacion Financiera.pdf"
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/EXCEL/4.-Estado Cambios Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/4.Estado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            }
        ]
    },
   
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/EEstado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financieraxlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/EEstado de Cambios en la Situacion Financiera.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Estado de Cambios en la Situacion Financiera.pdf",
                    }
            
                ]
                
            }
        ]
    },

];

export const ACEstadoPasivosC = [
     {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
           /*{
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },*/
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/EXCEL/8.- Informe de Pasivo Contingente.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/f).- Informe de Pasivos Contingentes.pdf",
                        
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/EXCEL/8.PasivosContingentes.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/8.Informe de Pasivo Contingente.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/EXCEL/8.-Pasivos Contingentes.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/8.Informe sobre Pasivos Contingentes.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/EXCEL/8.-Pasivos Contingentes.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/8.Informe sobre Pasivos Contingentes.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
            
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Informes pasivos.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const ACNotasEF = [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
          /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },*/
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/EXCEL/g) Notas a los estados financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/g).- Notas a los Estados Financieros.pdf",
                        
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/9.NOTAS A LOS ESTADOS FINANCIEROS 2T.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/9.NOTAS A LOS ESTADOS FINANCIEROS.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/9.NOTAS A LOS ESTADOS FINANCIEROS.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Notas de Estados Financieros.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const ACEstadoAnaliticoA = [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            },
           /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            }, */
        ]
    }, 
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            }, 
        ]
    }, 
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            },
            
           
        ]
    }, 
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/EXCEL/6.- Estado Analitico del Activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/h).- Estado Analitico del Activo.pdf",
                        
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/EXCEL/6.Estado Analitico del Activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/6.Estado Analitico del Activo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/EXCEL/6.-Estado Analitico De Activos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/6.Estado Analitico del Activo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/EXCEL/6.-Estado Analitico De Activos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/6.Estado Analitico del Activo.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Estado Analitico del activo.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const ACEstadoFlujoE = [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
          /*  {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },*/
        
        ]
    }, 
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
        
        ]
    }, 
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
        
        ]
    }, 
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/EXCEL/5.- Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/e).- Estado de Flujos de Efectivo.pdf",
                        
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/EXCEL/5.Estado de Flujos de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/5.Estado de Flujo de Efectivo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/EXCEL/5.-Estado Flujos Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/5.Estado de Flujos de Efectivo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/EXCEL/5.-Estado Flujos Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/5.Estado de Flujos de Efectivo.pdf",
                    }
                ] 
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            }
        ]
    },


    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]   
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Estado de Flujo de Efectivo.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const ACEstadoAnaliticoDyOP = [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
         /*   {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },*/
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/EXCEL/7.- Estado Analitico de la Deuda y Otros Pasivos.xlsx",
                        "pdf" : "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/1.- CONTABLE/i).- Estado Analitico de la Deuda y Otros Pasivos.pdf",
                        
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/EXCEL/7.Estado Analitico de la Deuda y otros Pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/1.-CONTABLES/7.Estado Analitico de la Deuda y Otros Pasivos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/EXCEL/7.-Estado Analitico Deuda Y Pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/7.Estado Analitico de la Deuda y Otros Pasivo.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/EXCEL/7.-Estado Analitico Deuda Y Pasivos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/1.CONTABLES/7.Estado Analitico de la Deuda y Otros Pasivo.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                     "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION CONTABLE/Estado Analitico de la deuda.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

/*BLOQUE INFORMACION PRESUPUESTARIA*/

export const IPEstadoAnaliticoI = [
   {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
          /*  {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },*/
        ]
    },  
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
        ]
    }, 
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/EXCEL/1.- Estado Analitico de Ingresos.xlsx",*/
                        "pdf" : "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/01.- Estado Analitico de Ingresos.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/EXCEL/1. Estado Analitico de Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/1. Estado Analitico de Ingresos.pdf",
                    }
                ]
            },
            {
               "trimestreNombre" : "Tercer Trimestre",
               "trimestreContenido" : [
                   {
                       /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/1.-Estado Analitico De Ingresos.xlsx",*/
                       "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/1.Estado Analitico de Ingresos.pdf",
                   }
               ]
           },
           {
              "trimestreNombre" : "Cuarto Trimestre",
              "trimestreContenido" : [
                  {
                      /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/1.-Estado Analitico De Ingresos.xlsx",*/
                      "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/1.Estado Analitico de Ingresos.pdf",
                  }
              ]
          }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
            
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/ 
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Analitico De Ingresos.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const IPEstadoAnaliticoEPECPOG = [
     {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
          /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },*/
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
        ]
    },  
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
        ]
    }, 
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/EXCEL/3.- Estado del Ejercicio del Presupuesto por COG..xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/03.- Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            }, 
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/EXCEL/3. Estado del Ejercicio del Presupuesto por COG.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/3. Estado de Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            }, 
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/3.-Estado Del Ejercicio Del Presupuesto Por COG.xlsx",
                        "pdf" :"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/3.Estado del Ejercicio del Presupuesto de Egresos por Capitulo del Gasto.pdf",
                    }
                ]
            }, 
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/3.-Estado Del Ejercicio Del Presupuesto Por COG.xlsx",
                        "pdf" :"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/3.Estado del Ejercicio del Presupuesto de Egresos por Capitulo del Gasto.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto por COG.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const IPEstadoAnaliticoEPEPCE = [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
          /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },*/
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/EXCEL/5.- Estado del Ejercicio del Presupuesto de Egresos CE.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/05.- Estado del Ejercicio del Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/EXCEL/5. Estado del Ejercicio de Presupuesto de Egresos CE.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/5. Estado de Ejercicio del Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
            {
               "trimestreNombre" : "Tercer Trimestre",
               "trimestreContenido" : [
                   {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/5.-Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",
                       "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/5.Estado Analitico del Ejercicio del Presupuesto de Egresos Clasificacion Economica (Por tipo de Gasto).pdf",
                   }
               ]
           },
           {
              "trimestreNombre" : "Cuarto Trimestre",
              "trimestreContenido" : [
                  {
                      "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/5.-Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",
                      "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/5.Estado Analitico del Ejercicio del Presupuesto de Egresos Clasificacion Economica (Por tipo de Gasto).pdf",
                  }
              ]
          }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       /*  "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CE.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CE.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const IPEstadoAnaliticoEPECF = [
     {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.pdf",
                    }
                ]
            },
          /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.pdf",
                    }
                ]
            },
              {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.pdf",
                    }
                ]
            },*/

        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.pdf",
                    }
                ]
            },
              {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.pdf",
                    }
                ]
            },

        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egesos CF.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Presupuesto de Egresos CF.pdf",
                    }
                ]
            },

        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/EXCEL/6.- Estado del Ejercicio del Presupuesto de  Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/06.- Estado del Ejercicio del Presupuesto de Egesos  CF.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/EXCEL/6. Estado del Ejercicio del Presupuesto de Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/6. Estado de Ejercicio del Presupuesto de Egresos CF.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/6.- Estado Del Ejercicio Del Presupuesto De Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/6.Estado Analitico del Ejercicio del Presupuesto de Egresos Clasificacion Funcional (Finalidad y Funcion).pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/6.- Estado Del Ejercicio Del Presupuesto De Egresos CF.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/6.Estado Analitico del Ejercicio del Presupuesto de Egresos Clasificacion Funcional (Finalidad y Funcion).pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CF.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del del Presupuesto de Egesos CF.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const IPEstadoAnaliticoEPECP = [
     {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" :  "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
           /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },*/
        ]
    }, 
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" :  "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
        ]
    }, 
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" :  "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/3.- PROGRAMATICA/EXCEL/1.- Gasto por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/3.- PROGRAMATICA/a).- Gasto por Categoria Programatica.pdf"
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/3.-PROGRAMATICOS/EXCEL/1. Gasto por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/3.-PROGRAMATICOS/1. Gasto por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/3.PROGRAMATICOS/EXCEL/1.-Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/3.PROGRAMATICOS/1.Gasto por Categoria Programatica.pdf", 
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/3.PROGRAMATICOS/EXCEL/1.-Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/3.PROGRAMATICOS/1.Gasto por Categoria Programatica.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION /Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            /*{
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica CF.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }*/
            
                ]
                
            }, 
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    
                {  /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/20/1erTrimestre/INFORMACION PRESUPUESTAL /Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica CF.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            }
        ]
    },

    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica CF.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL /Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica CF.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL /Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica CF.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            }
        ]
    },

];

export const IPEstadoAnaliticoEPECA= [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
          /*  {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.pdf",
                    }*/
                ]
            },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
           
        ]
    }, 
     {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio de Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
           
        ]
    }, 
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/EXCEL/4.- Estado del Ejercicio del Presupuesto de Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/04.- Estado del Ejercicio del Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/EXCEL/4. Estado del Ejercicio del Presupuesto de Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/4. Estado de Ejercicio del Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/4.-Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/4.Estado del Ejercicio del Presupuesto de Egresos por Unidad Adminstrativa.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/4.-Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/4.Estado del Ejercicio del Presupuesto de Egresos por Unidad Adminstrativa.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto de Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto de Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto de Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto de Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto de Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Estado del Ejercicio del Presupuesto de Egresos CA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Estado Del Ejercicio Del Presupuesto De Egresos CA.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const IPEndeudamientoNeto= [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
          /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }*/
                ]
            },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
             
             
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
             
             
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/EXCEL/9.- Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/09.- Endeudamiento Neto.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/EXCEL/9. Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/9. Endeudamiento Neto.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/9.-Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/9.Endeudamiento Neto.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/9.-Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/9.Endeudamiento Neto.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
            
                 ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ] 
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ] 
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ] 
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Endeudamiento Neto.pdf",
                    }
                ] 
            }
        ]
    },
];

export const IPInteresdelaDeuda= [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
          /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },*/
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/EXCEL/10.- Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/10.- Intereses de la Deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/EXCEL/10. Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/10. Intereses de la Deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/10.-Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/10.Intereses de la Deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/10.-Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/10.Intereses de la Deuda.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    
                    {    "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Intereses de la Deuda.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const IPResumenFdFIPF= [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
          /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },*/
        
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
        
        ]
    }, 
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
        
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/EXCEL/8.- Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/2.- PRESUPUESTARIA/08.- Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/EXCEL/8. Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/2.-PRESUPUESTALES/8. Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/8.-Indicadores De Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/8.Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/EXCEL/8.-Indicadores De Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/2.PRESUPUESTALES/8.Indicadores de Postura Fiscal.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]   
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PRESUPUESTAL/Indicadores de Postura Fiscal.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

/* BLOQUE INFORMACION PROGRAMATICA*/

export const IPGastoPCP = [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
          /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },*/
        
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PRESUPUESTAL/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
        
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/3.- PROGRAMATICA/EXCEL/1.- Gasto por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/3.- PROGRAMATICA/a).- Gasto por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/3.-PROGRAMATICOS/EXCEL/1. Gasto por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/3.-PROGRAMATICOS/1. Gasto por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/3.PROGRAMATICOS/EXCEL/1.-Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/3.PROGRAMATICOS/1.Gasto por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/3.PROGRAMATICOS/EXCEL/1.-Gasto Por Categoria Programatica.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/3.PROGRAMATICOS/1.Gasto por Categoria Programatica.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PROGRAMATICA/Gasto Por Categoria Programatica.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const IPProgramasyPI = [
   {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
           /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },*/
        ]
    }, 
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/3.- PROGRAMATICA/EXCEL/2.- Proyectos y programas de Inversion.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/3.- PROGRAMATICA/b).- Proyectos y programas de inversion.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/3.-PROGRAMATICOS/EXCEL/2. Proyectos y programas de Inversión.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/3.-PROGRAMATICOS/2. Proyectos y Programas de Inversión.pdf",
                    }
                ]
            },
            {
               "trimestreNombre" : "Tercer Trimestre",
               "trimestreContenido" : [
                   {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/3.PROGRAMATICOS/EXCEL/2.-Proyecto Y Programas de Inversion.xlsx",
                       "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/3.PROGRAMATICOS/2.Programas y proyectos de Inversion.pdf",
                   }
               ]
           },
           {
              "trimestreNombre" : "Cuarto Trimestre",
              "trimestreContenido" : [
                  {
                      "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/3.PROGRAMATICOS/EXCEL/2.-Proyecto Y Programas de Inversion.xlsx",
                      "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/3.PROGRAMATICOS/2.Programas y proyectos de Inversion.pdf",
                  }
              ]
          }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PROGRAMATICA/Proyecto Y Programas de Inversion.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const IPIndicadoresR = [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
          /*  {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },*/
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
           {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria//AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/3.- PROGRAMATICA/INDICADORES DE RESULTADOS  1er. trimestre.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/3.-PROGRAMATICOS/INDICADORES DE RESULTADOS 2DO. TRIM.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/5.INDICADORES DE RESULTADOS/INDICADORES DE RESULTADOS.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/5.INDICADORES DE RESULTADOS/INDICADORES DE RESULTADOS.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.xlsx",*/
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf",
                    }
            
                ]
                
            }
        ]
    },
];


/* OBLIGACIONES TRANSPARENCIA 

export const CDEvaluaciones= [
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer semestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/MUEBLES_ AL_30_DE_JUNIO_2023.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erSemestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erSemestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doSemestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doSemestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
            
                ]
                
            },
            
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erSemestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erSemestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doSemestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doSemestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
            
                ]
                
            },
            
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erSemestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erSemestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doSemestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doSemestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
            
                ]
                
            },
            
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erSemestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erSemestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doSemestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doSemestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
            
                ]
                
            },
            
        ]
    },
    
]; 

export const PAEvaluaciones= [
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer semestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/INMUEBLES_AL_30_DE_JUNIO_2023.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    } 
                ]  
            },
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]  
            },
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]  
            },
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doSemestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]  
            },
        ]
    },
] 

/* BLOQUE INVENTARIO DE BIENES */

export const InventarioBienesM = [
    {
        "anio" : "2026",
        "trimestre" : [
           /*{
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },*/
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
           {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer semestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/MUEBLES_ AL_30_DE_JUNIO_2023.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo semestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/MUEBLES_ AL_30_DE_JUNIO_2023.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            }, 
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            }, 
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                     "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                     "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
        ]
        
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                      "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                      "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                      "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                      "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INVENTARIO DE BIENES/Bienes Muebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INVENTARIO DE BIENES/Bienes Muebles.pdf",
                    }
                ]
            },
        ]
    },
];

export const InventarioBienesI = [
   {
        "anio" : "2026",
        "trimestre" : [
        /* {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },*/
        
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
         {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
        
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
        
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/INMUEBLES_AL_30_DE_JUNIO_2023.pdf"
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/INMUEBLES_AL_30_DE_JUNIO_2023.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
        
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
           
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
            
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Semestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/INVENTARIO DE BIENES/Bienes Inmuebles.pdf",
                    }
                ]
            },
        ]
    },
]

/* BLOQUE OBLIGACIONES DEL TITULO QUINTO*/

export const TQEstructuradIMPPAyS = [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
           /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },*/
            
        ]
    }, 
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            
        ]
    }, 
   {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            
        ]
    }, 
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/word/m p a s  1 e r  T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/m p a s  1 e r  T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/word/m p a s  2 d o T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/m p a s  2 d o T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/m p a s  3 e r T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/m p a s  3 e r T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/m p a s  3 e r T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/m p a s  3 e r T.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ] 
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                   {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ] 
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/MONTOS POR AYUDAS Y SUBSIDIOS.pdf",
                    }
            
                ]
                
            }
        ]
    },


];

export const TQProgramasCRFPODG = [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
           /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },*/
        ]
    },  
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
        ]
    }, 
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
        ]
    }, 
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/word/p r c o g  3 e r T.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/p r c o g  3 e r T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/word/p r c o g 2 d o T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/p r c o g  2 d o T.pdf", 
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/p r c o g 3 e r T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/p r c o g  3 e r T.pdf", 
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/p r c o g  3 e r T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/p r c o g  3 e r T.pdf",
                    }
                ]
            }
            
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PROGRAMATICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
            
                ]
                
            }
        ]
    }, 
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PROGRAMATICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
            
                ]
                
            }
        ]
    }, 
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PROGRAMATICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PROGRAMATICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PROGRAMATICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/RECURSOS POR ORDEN DE GOBIERNO.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const TQAportacionesFeMdS = [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
           /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },*/
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/word/a f m s  1 e r T.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/a f m s  1 e r T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/word/a f m s 2 d o T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/a f m s 2 d o T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/a f m s 3 e r T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/a f m s  3 e r T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/a f m s  3 e r T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/a f m s  3 e r T.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PROGRAMATICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PROGRAMATICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PROGRAMATICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            }
        ]
    },
    
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PROGRAMATICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PROGRAMATICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
                ]
            }
        ]
    },

];

export const TQFondodAFplSP = [
     {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
           /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer  Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto  Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },*/
        ]
    }, {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer  Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto  Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
        ]
    }, 
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer  Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto  Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
        ]
    }, 
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/word/a r p s p   1 e r T.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/a r p s p   1 e r T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/word/a r p s p  2 d o T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/a r p s p  2 d o T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/a r p s p  3 e r T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/a r p s p   3 e r T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/a r p s p  3 e r T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/a r p s p   3 e r T.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PROGRAMATICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/APORTACIONES EN MATERIA DE SALUD.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PROGRAMATICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PROGRAMATICA/PROGRAMAS DE SEGURIDAD PUBLICApdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                      "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PROGRAMATICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                    }
            
                ]
                
            }
        ]
    },
    { "anio" : "2018",
    "trimestre" : [
        {
            "trimestreNombre" : "Primer Trimestre",
            "trimestreContenido" : [
                {
                    "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                    "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                }
            ]
        },
        {
            "trimestreNombre" : "Segundo Trimestre",
            "trimestreContenido" : [
                {
                     "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                    "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                }
        
            ]
            
        },
        {
            "trimestreNombre" : "Tercer Trimestre",
            "trimestreContenido" : [
                {
                    "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                    "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PROGRAMATICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                }
        
            ]
            
        },
        {
            "trimestreNombre" : "Cuarto Trimestre",
            "trimestreContenido" : [
                {
                    "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.xlsx",
                    "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/PROGRAMAS DE SEGURIDAD PUBLICA.pdf",
                }
        
            ]
            
        }
    ]
},

]; 

export const TQInformaciondOPoGcFF = [
    {
        "anio" : "2026",
        "trimestre" : [
          {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
           /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
             {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },*/
        ]
    }, 
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
           
           
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
           
           
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/word/o p g f f  1 e r  T.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/o p g f f  1 e r  T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/word/o p g f f 2 d o T.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/o p g f f 2 d o T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/o p g f f 3 e r T.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/o p g f f 3 e r T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/o p g f f  3 e r T.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/o p g f f  3 e r T.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PROGRAMATICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PROGRAMATICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PROGRAMATICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PROGRAMATICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PROGRAMATICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/OBLIGACIONES CON FONDO FEDERAL.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const TQEjercicioyDdGFyR = [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
            /*{
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },*/
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/word/e d g f r  1 e r  T.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/e d g f r  1 e r  T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/word/e d g f r 2 d o T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/e d g f r 2 d o T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/e d g f r 3 e r T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/e d g f r 3 e r T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/e d g f r  3 e r T.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/e d g f r 3 e r T.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PROGRAMATICA/GASTO FEDERALIZADO.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PROGRAMATICA/GASTO FEDERALIZADO.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PROGRAMATICA/GASTO FEDERALIZADO.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PROGRAMATICA/GASTO FEDERALIZADO.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    
                     {    "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PROGRAMATICA/GASTO FEDERALIZADO.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/GASTO FEDERALIZADO.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const TQAportacionesFdlFdAplE = [ 
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                      "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
           /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
              {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },*/
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                      "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
           {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
              {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                      "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
            
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/word/f a e t a  1 e r T.doc",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/f a e t a  1 e r T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/word/f a e t a 2 d o T.doc",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/f a e t a 2 d o T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/f a e t a 3 e r T.doc",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/f a e t a 3 e r T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/f a e t a  3 e r T.doc",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/f a e t a 3 e r T.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PROGRAMATICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
            
                ]
                
            }
        ]
    },

    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PROGRAMATICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                         "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PROGRAMATICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/FONDO POR LA EDUCACION TECNOLOGICA.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

export const TQAplicaciondRFORTAMUN = [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
                ]
            },
           /* {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/2doTrimestre/FORMATOS NO APLICA//FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/3erTrimestre/FORMATOS NO APLICA//FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/4toTrimestre/FORMATOS NO APLICA//FORTAMUN.pdf",
                    }
                ]
            },*/
        ]
    },  
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/2doTrimestre/FORMATOS NO APLICA//FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/3erTrimestre/FORMATOS NO APLICA//FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/4toTrimestre/FORMATOS NO APLICA//FORTAMUN.pdf",
                    }
                ]
            },
        ]
    },  
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/2doTrimestre/FORMATOS NO APLICA//FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/3erTrimestre/FORMATOS NO APLICA//FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/4toTrimestre/FORMATOS NO APLICA//FORTAMUN.pdf",
                    }
                ]
            },
        ]
    }, 
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/word/f a f m d d f  1 e r  T.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/4.- FORMATOS NO APLICA/f a f m d d f  1 e r  T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/word/f a f m d d f 2 d o T.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/2do.trimestre/LEY GENERAL DE CONTABILIDAD/4.-FORMATOS NO APLICA/f a f m d d f 2 d o T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/f a f m d d f 3 e r T.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/3erTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/f a f m d d f 3 e r T.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/word/f a f m d d f  3 e r T.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/4toTrimestre/CONTABILIDADGUBERNAMENTAL/4.FORMATOS NO APLICA/f a f m d d f 3 e r T.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PROGRAMATICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PROGRAMATICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PROGRAMATICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PROGRAMATICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                         "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/3erTrimestre/INFORMACION PROGRAMATICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                        "docx" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.docx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            }
        ]
    },
];

/* BLOQUE OBLIGACIONES DEL TITULO QUINTO LGCG ANUAL*/
 
export const NpaLeydeIngresos= [
     {
        "anio" :"2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/Anuales/Norma de la Ley de Ingresos.xlsx",    
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/Anuales/Norma de la Ley de Ingresos.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" :"2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/Anuales/Norma de la Ley de Ingresos.xlsx",    
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/Anuales/Norma de la Ley de Ingresos.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" :"2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/Anuales/Norma de la Ley de Ingresos.xlsx",    
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/Anuales/Norma de la Ley de Ingresos.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" :"2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2023/Anuales/Norma de la Ley de Ingresos.xlsx",    
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2023/Anuales/Norma de la Ley de Ingresos.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/Anuales/Norma de la Ley de Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/Anuales/Norma de la Ley de Ingresos.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/Anuales/Norma de la Ley de Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/Anuales/Norma de la Ley de Ingresos.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/Anuales/Norma de la Ley de Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/Anuales/Norma de la Ley de Ingresos.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/Anuales/Norma de la Ley de Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/Anuales/Norma de la Ley de Ingresos.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/Anuales/Norma de la Ley de Ingresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/Anuales/Norma de la Ley de Ingresos.pdf",
                    }
                ]
            }
        ]
    },
    
];

export const  NpalpIaPredEgresos= [
     {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/Anuales/Norma del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/Anuales/Norma del Presupuesto de Egresos.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/Anuales/Norma del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/Anuales/Norma del Presupuesto de Egresos.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/Anuales/Norma del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/Anuales/Norma del Presupuesto de Egresos.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2023/Anuales/Norma del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2023/Anuales/Norma del Presupuesto de Egresos.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/Anuales/Norma del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/Anuales/Norma del Presupuesto de Egresos.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/Anuales/Norma del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/Anuales/Norma del Presupuesto de Egresos.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/Anuales/Norma del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/Anuales/Norma del Presupuesto de Egresos.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/Anuales/Norma del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/Anuales/Norma del Presupuesto de Egresos.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/Anuales/Norma del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/Anuales/Norma del Presupuesto de Egresos.pdf",
                    }
                ]
            }
        ]
    },
];

export const  NpalpleyPredEgresos= [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2023/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2023/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.pdf"
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/Anuales/Norma de la Ley de Ingresos y del Presupuesto de Egresos.pdf",
                    }
                ]
            }
        ]
    },
];
export const  NpaEeIngresosBaseM= [
   {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/Anuales/Norma de Ingresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/Anuales/Norma de Ingresos base mensual.pdf",
                    }
                ]
            }
           
        ]
    },
     {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/Anuales/Norma de Ingresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/Anuales/Norma de Ingresos base mensual.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/Anuales/Norma de Ingresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/Anuales/Norma de Ingresos base mensual.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2023/Anuales/Norma de Ingresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2023/Anuales/Norma de Ingresos base mensual.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/Anuales/Norma de Ingresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/Anuales/Norma de Ingresos base mensual.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/Anuales/Norma de Ingresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/Anuales/Norma de Ingresos base mensual.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/Anuales/Norma de Ingresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/Anuales/Norma de Ingresos base mensual.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/Anuales/Norma de Ingresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/Anuales/Norma de Ingresos base mensual.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/Anuales/Norma de Ingresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/Anuales/Norma de Ingresos base mensual.pdf",
                    }
                ]
            }
        ]
    },
    
];
export const  NpalecEgresosBaseM= [
   {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/Anuales/Norma de Egresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/Anuales/Norma de Egresos base mensual.pdf",
                    }
                ]
            }
           
        ]
    }, 
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/Anuales/Norma de Egresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/Anuales/Norma de Egresos base mensual.pdf",
                    }
                ]
            }
           
        ]
    },
     {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/Anuales/Norma del Presupuesto de Egresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/Anuales/Norma del Presupuesto de Egresos base mensual.pdf"
                    }
                ]
            }
           
        ]
    }, 
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2023/Anuales/Norma del Presupuesto de Egresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2023/Anuales/Norma del Presupuesto de Egresos base mensual.pdf"
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/Anuales/Norma del Presupuesto de Egresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/Anuales/Norma del Presupuesto de Egresos base mensual.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                     "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/Anuales/Norma del Presupuesto de Egresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/Anuales/Norma del Presupuesto de Egresos base mensual.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/Anuales/Norma del Presupuesto de Egresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/Anuales/Norma del Presupuesto de Egresos base mensual.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/Anuales/Norma del Presupuesto de Egresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/Anuales/Norma del Presupuesto de Egresos base mensual.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/Anuales/Norma del Presupuesto de Egresos base mensual.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/Anuales/Norma del Presupuesto de Egresos base mensual.pdf",
                    }
                ]
            },
        ]
    },
    
    
];
export const NelerFTransferido= [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/Anuales/Norma en la que se depositan recursos federales.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/Anuales/Norma en la que se depositan recursos federales.pdf",
                    }
                ]
            }
           
        ]
    },
     {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/Anuales/Norma en la que se depositan recursos federales.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/Anuales/Norma en la que se depositan recursos federales.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/Anuales/Norma en la que se depositan recursos federales.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/Anuales/Norma en la que se depositan recursos federales.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2023/Anuales/Norma en la que se depositan recursos federales.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2023/Anuales/Norma en la que se depositan recursos federales.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/Anuales/Norma en la que se depositan recursos federales.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/Anuales/Norma en la que se depositan recursos federales.pdf",
                    }
                ]
            } 
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/Anuales/Norma en la que se depositan recursos federales.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/Anuales/Norma en la que se depositan recursos federales.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/Anuales/Norma en la que se depositan recursos federales.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/Norma en la que se depositan recursos federales.pdf",
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/Anuales/Norma en la que se depositan recursos federales.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/Anuales/Norma en la que se depositan recursos federales.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/Anuales/Norma en la que se depositan recursos federales.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/Anuales/Norma en la que se depositan recursos federales.pdf",
                    }
                ]
            },
        ]
    },
];
/*export const  LiffondopISocial= [
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/1erTrimestre/3.- LEY GENERAL DE CONTABILIDAD/"
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                       "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/3erTrimestre/INFORMACION PROGRAMATICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/3erTrimestre/INFORMACION PROGRAMATICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /*"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/3erTrimestre/INFORMACION PROGRAMATICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            }
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Primer Trimestre",
                "trimestreContenido" : [
                    {
                       /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/1erTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
                ]
            },
            {
                "trimestreNombre" : "Segundo Trimestre",
                "trimestreContenido" : [
                    {
                        /* "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/2doTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Tercer Trimestre",
                "trimestreContenido" : [
                    {
                        /"excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/3erTrimestre/INFORMACION PROGRAMATICA/FORTAMUN.pdf",
                    }
            
                ]
                
            },
            {
                "trimestreNombre" : "Cuarto Trimestre",
                "trimestreContenido" : [
                    {
                       "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/4toTrimestre/FORMATOS NO APLICA/FORTAMUN.pdf",
                    }
            
                ]
                
            }
        ]
    },
]; */
export const  RefEntiFederativas= [
    {
        "anio" : "2026",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/Anuales/Normas de gasto federalizado y reintegros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2026/Anuales/Normas de gasto federalizado y reintegros.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2025",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/Anuales/Normas de gasto federalizado y reintegros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/Anuales/Normas de gasto federalizado y reintegros.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2024",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/Anuales/Normas de gasto federalizado y reintegros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/Anuales/Normas de gasto federalizado y reintegros.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2023",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2023/Anuales/Normas de gasto federalizado y reintegros.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2023/Anuales/Normas de gasto federalizado y reintegros.pdf",
                    }
                ]
            }
           
        ]
    },
    {
        "anio" : "2022",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/Anuales/Normas de gasto federalizado y reintegro.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2022/Anuales/Normas de gasto federalizado y reintegro.pdf",
                    }
                ]
            },
        ]
    },
    {
        "anio" : "2021",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/Anuales/Normas de gasto federalizado y reintegro.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2021/Anuales/Normas de gasto federalizado y reintegro.pdf",
                    }
                ]
            },
           
        ]
    },
    {
        "anio" : "2020",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/Anuales/Normas de gasto federalizado y reintegro.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2020/Anuales/Normas de gasto federalizado y reintegro.pdf",
                    }
                ]
            },
          
        ]
    },
    {
        "anio" : "2019",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/Anuales/Normas de gasto federalizado y reintegro.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2019/Anuales/Normas de gasto federalizado y reintegro.pdf",
                    }
                ]
            },
            
        ]
    },
    {
        "anio" : "2018",
        "trimestre" : [
            {
                "trimestreNombre" : "Anual",
                "trimestreContenido" : [
                    {
                        "excel" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/Anuales/Normas de gasto federalizado y reintegro.xlsx",
                        "pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/armonizacionContable/2018/Anuales/Normas de gasto federalizado y reintegro.pdf",
                    }
                ]
            },
            
        ]
    },
];





